module.exports = __webpack_public_path__ + "static/media/cv_i.ae898f76.jpg";